/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { DiffValue } from "./DiffValue";
export const DiffData = core.serialization.record(core.serialization.string(), DiffValue);
